import { render, staticRenderFns } from "./RatingCommentsList.vue?vue&type=template&id=e2965708&scoped=true&"
import script from "./RatingCommentsList.vue?vue&type=script&lang=js&"
export * from "./RatingCommentsList.vue?vue&type=script&lang=js&"
import style0 from "./RatingCommentsList.vue?vue&type=style&index=0&id=e2965708&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2965708",
  null
  
)

export default component.exports